<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-col lg="12" class="d-flex align-items-center justify-content-center flex-column text-center p-5">
        <b-spinner v-if="loading" label="Loading..."></b-spinner>
        <div v-else>
          <h2 v-if="error" class="text-danger mb-2">{{ error }}</h2>
          <h2 v-else class="text-success mb-2">Finalizing your account...</h2>
          <p v-if="!error">Please wait while we log you in automatically.</p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BSpinner
} from 'bootstrap-vue'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { DASHBOARD_ACCESS } from '@/helpers/permissionsConstant'

export default {
  name: 'PaymentSuccess',
  components: { BRow, BCol, BSpinner },
  data() {
    return {
      loading: true,
      error: null,
    }
  },
  async mounted() {
    const sessionId = this.$route.query.session_id
    const token = this.$route.query.token

    if (!sessionId || !token) {
      this.error = 'Missing verification parameters.'
      this.loading = false
      return
    }

    try {
      // 1️⃣ Call backend to verify Stripe session
      const resLogin = await this.$api.post('/api/auth/stripe-login', {
        session_id: sessionId,
        token: token,
      })

      const data = resLogin?.data

      if (!data?.access_token) {
        throw new Error(data?.error || 'Stripe login failed.')
      }

      // 2️⃣ Store tokens in Vuex (reuse your authModule)
      await this.$store.dispatch('authModule/setIsAuthenticated', {
        isAuthenticated: true,
        token: data?.access_token,
        refreshToken: data?.refresh_token,
      })

      // 3️⃣ Load global settings (same as in normal login)
      const settings = await this.$api.get('/api/settings')
      store.commit('app/setGlobalDateFormat', settings?.data?.data?.date_format)

      // 4️⃣ Update company logo
      const resCompany = await this.$api.get('/api/companies/current')
      if (resCompany) {
        await this.$store.dispatch('authModule/setCompanyLogo', {
          companyLogo: resCompany?.data?.data?.logo,
        })
      }

      // 5️⃣ Reset filters
      store.dispatch('allTaskModule/resetFilters')
      store.dispatch('globalTrackerModule/resetFilters')
      store.dispatch('boardModule/resetFilters')

      // 6️⃣ Fetch authenticated user & permissions
      const resUser = await this.$api.post('/api/user?include=permissions,designation,roles,department')
      const { permissions, ...user } = resUser?.data?.data
      const mapPermissions = permissions?.data.map(item => item.name)

      await this.$store.dispatch('userModule/setUser', { user })
      await this.$store.dispatch('userModule/setPermissions', {
        permissions: mapPermissions,
      })

      // 7️⃣ Get payment method
      const paymentMethod = await this.$api.get(`/api/company-payment-method/${user.id}`)
      await this.$store.dispatch('paymentMethodModule/setPaymentMethod', {
        paymentMethod: paymentMethod?.data,
      })

      // 8️⃣ Redirect to dashboard
      let routeName = 'admin-dashboard'
      if (mapPermissions.includes(DASHBOARD_ACCESS)) {
        routeName = 'admin-dashboard'
      }

      this.$router.replace({ name: routeName }).then(() => {
        this.loading = false
        window.location.reload()
      })
    } catch (err) {
      console.error(err)
      this.error = err?.response?.data?.message || err?.message || 'Auto login failed.'
      this.loading = false

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
          text: this.error,
        },
      })
    }
  },
}
</script>
